import { useEffect, useState } from "react";

export const useHashDetection = () => {
  const [hash, setHash] = useState<string | null>(null);
  const [hasInitialHash, setHasInitialHash] = useState(false);

  useEffect(() => {
    // Check for hash on initial page load
    const initialHash = window.location.hash.replace("#", "");
    if (initialHash) {
      setHash(initialHash);
      setHasInitialHash(true);
    }

    // Listen for hash changes (when user navigates)
    const handleHashChange = () => {
      const currentHash = window.location.hash.replace("#", "");
      setHash(currentHash || null);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return {
    hash,
    hasInitialHash,
    clearHash: () => setHash(null),
  };
};
